<template>
  <div class="row mx-0 px-3 py-4 border-top">
    <Field
      v-slot="{ field, errors }"
      v-model="resumeEducation.other_educational_backgrounds"
      name="other_educational_backgrounds"
    >
      <div class="input-group row pe-0">
        <div class="col-12 pe-0">
          <label class="form-label size-12" for="">学歴メモ（その他学歴）</label>
          <textarea
            class="form-control bg-silver-primary input-primary size-14 border-0"
            rows="6"
            placeholder="学歴について補足があればご入力ください。"
            v-bind="field"
            :class="{ 'is-invalid': !!errors.length }"
          ></textarea>
          <div
            class="d-flex justify-content-end mt-2 size-10"
            :class="
              resumeEducation.other_educational_backgrounds?.length > 300
                ? 'text-danger'
                : 'text-black-50'
            "
          >
            {{ resumeEducation.other_educational_backgrounds?.length || 0 }}
            /300（最大文字数300文字）
          </div>
          <ErrorMessage name="other_educational_backgrounds" class="invalid-feedback" />
        </div>
      </div>
    </Field>
  </div>
</template>

<script setup lang="ts">
import { Field, ErrorMessage } from 'vee-validate';
import { useResumeEducationStore } from '@/stores/resume-candidate/ResumeEducation.store';
const resumeEducation = useResumeEducationStore();
</script>
